import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://hiqquxndveachhctwxzk.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhpcXF1eG5kdmVhY2hoY3R3eHprIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzkwMzA1MzAsImV4cCI6MjA1NDYwNjUzMH0.ER3YX1UEN8GO6d3m1xrSpwIJvkz_ihqG5svBrN2NgGU';

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: window.localStorage
  }
});